import { createStore, applyMiddleware, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { getLoginData } from 'signin-app/api/helpers/local-storage';
import { InstitutionOverviewState } from 'signin-app/groups/reducer';
import * as LocalStorage from 'signin-app/api/helpers/local-storage';
import { LoginState } from '../login/reducer';
import createRootReducer from './main-reducer';
import rootEpic from '../root-epic';
// create the middleware
const epicMiddleware = createEpicMiddleware();
const composeEnhancers = (process.env.NODE_ENV !== 'production' && window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const loginData = getLoginData();
const getHiddenGroupIds = () => {
    const hiddenGroupIds = LocalStorage.getHiddenGroupIds();
    return hiddenGroupIds !== null && hiddenGroupIds !== void 0 ? hiddenGroupIds : [];
};
/**
 * The redux types of createStore now seem to requires a complete RootState to be passed down.
 * This is inconsistent with redux itself which accepts a partial RootState as preloadState
 */
const preloadedState = {
    login: new LoginState({
        accessToken: loginData.accessToken,
        pinSigninAvailable: loginData.pinSigninAvailable,
        qrSigninAvailable: loginData.qrSigninAvailable,
        siteId: loginData.siteId,
    }),
    institutionOverview: new InstitutionOverviewState({
        hiddenGroupIds: getHiddenGroupIds(),
    }),
};
export const history = createBrowserHistory({
// basename: '/v2/',
});
const store = createStore(createRootReducer(history), preloadedState, composeEnhancers(applyMiddleware(routerMiddleware(history), epicMiddleware)));
epicMiddleware.run(rootEpic);
export const getStore = () => store;
export default store;
